import { useQuery } from '@tanstack/react-query';
import useGlynt from '../hooks/useGlynt';
import { useContext } from 'react';
import { AppContext } from '../../App';
import type { MatDiscoveryKeysOnlyResponse } from '../../types/mat-types';

interface UseMatDiscoveryKeysArgs {
  enabled?: boolean;
  params?: Record<string, any>;
}

const useMatDiscoveryKeys = ({ enabled = true, params }: UseMatDiscoveryKeysArgs = {}) => {
  const glynt = useGlynt();
  const { dataPoolId } = useContext(AppContext);

  return useQuery({
    queryKey: ['mat-discovery-keys', dataPoolId, params],

    queryFn: async () => {
      const g = await glynt;
      return (await g.mat.matDiscoveryKeysOnly(params)) as MatDiscoveryKeysOnlyResponse;
    },

    enabled: enabled && !!dataPoolId,

    // 1 minute
    staleTime: 60_000
  });
};

export default useMatDiscoveryKeys;
